import Image from 'next/image';
import styled, { css } from 'styled-components';

import { ArticleDescription, ArticleHeader } from '@components/atoms';
import { device } from '@styles/mediaQuery';
import useDevice from '@hooks/useDevice';

type ServiceProps = {
  title: string;
  description: string;
  image: string;
};

function ServiceCard({ title, image, description }: ServiceProps) {
  const { isMobile } = useDevice();

  return (
    <Wrapper>
      <DescriptionWrapper>
        <ArticleHeader
          title={title}
          align="left"
          fontSizeL="24px"
          fontSizeM="18px"
          fontSize="12px"
          lineHeight="15px"
          lineHeightM="20px"
          lineHeightL="25px"
        />
        {!isMobile && (
          <ArticleDescription
            description={description}
            align="left"
            margin="5px 0 10px"
            fontSizeL="16px"
          />
        )}
      </DescriptionWrapper>

      <ImageWrapper>
        <Image
          fill
          alt={image}
          src={image}
          loading="lazy"
          sizes="(max-width: 1440px) 335px, (max-width: 935px) 338px, (max-width: 768px) 278px, (max-width: 375px) 139px"
        />
      </ImageWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 48%;

  min-height: 130px;
  max-width: 400px;
  border-radius: 12px;
  padding: 10px 10px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  background-color: ${({ theme }) => theme.colors.cardBackground};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};

  margin-bottom: 15px;

  ${device.mobileL(css`
    min-height: 230px;
  `)}

  ${device.tablet(css`
    min-height: 330px;
    height: 100%;
    padding: 30px 30px;
  `)}

  ${device.laptopS(css`
    width: 32%;
  `)}
`;

const DescriptionWrapper = styled.div`
  min-height: 35px;
  width: 100%;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 46.25%;

  max-height: 340px;
`;

export default ServiceCard;
